import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';

export default function SupplierPage() {
  const navigate = useNavigate();
  const [activeTab, setActiveTab] = useState('dashboard');
  const [supplierInfo, setSupplierInfo] = useState(null);

  useEffect(() => {
    const authData = localStorage.getItem('supplier_auth');
    if (!authData) {
      navigate('/supplier/login');
      return;
    }
    setSupplierInfo(JSON.parse(authData));
  }, [navigate]);

  if (!supplierInfo) {
    return null;
  }

  const tabs = [
    { id: 'dashboard', label: '대시보드', icon: 'ri-dashboard-line' },
    { id: 'products', label: '상품 공급', icon: 'ri-box-line' },
    { id: 'orders', label: '주문 관리', icon: 'ri-file-list-line' },
    { id: 'inventory', label: '재고 관리', icon: 'ri-stack-line' },
    { id: 'settlement', label: '정산 관리', icon: 'ri-money-dollar-circle-line' }
  ];

  const products = [
    { id: 1, name: '성경 가죽 커버', category: '성경/도서', price: 45000, stock: 500, merchants: 12 },
    { id: 2, name: '찬양 악보집', category: '찬양/음반', price: 28000, stock: 300, merchants: 8 },
    { id: 3, name: '십자가 목걸이', category: '악세서리', price: 35000, stock: 200, merchants: 15 },
    { id: 4, name: '묵상 노트', category: '문구/용품', price: 18000, stock: 1000, merchants: 20 }
  ];

  const handleLogout = () => {
    localStorage.removeItem('supplier_auth');
    navigate('/supplier/login');
  };

  return (
    <div className="min-h-screen bg-gray-50">
      <Navbar />
      
      <div className="pt-32 pb-24">
        <div className="max-w-7xl mx-auto px-6 lg:px-8">
          <div className="mb-8 flex items-center justify-between">
            <div>
              <h1 className="text-4xl font-bold text-gray-900 mb-2">공급사 관리</h1>
              <p className="text-gray-600">상품 공급과 재고를 관리하고 정산을 확인하세요</p>
            </div>
            <button
              onClick={handleLogout}
              className="px-4 py-2 bg-gray-600 text-white text-sm font-semibold rounded-lg hover:bg-gray-700 transition-colors whitespace-nowrap cursor-pointer"
            >
              <i className="ri-logout-box-line mr-2"></i>
              로그아웃
            </button>
          </div>

          <div className="grid grid-cols-1 lg:grid-cols-4 gap-8">
            <div className="lg:col-span-1">
              <div className="bg-white rounded-xl shadow-sm p-6 mb-6">
                <div className="text-center mb-6">
                  <div className="w-24 h-24 bg-blue-100 rounded-full flex items-center justify-center mx-auto mb-4">
                    <i className="ri-building-line text-4xl text-blue-600"></i>
                  </div>
                  <h3 className="text-xl font-bold text-gray-900 mb-1">{supplierInfo.name}</h3>
                  <p className="text-sm text-gray-600">{supplierInfo.role === 'admin' ? '통합관리자' : '공급사'}</p>
                </div>
                <div className="bg-gradient-to-br from-blue-50 to-blue-100 rounded-lg p-4">
                  <p className="text-sm text-gray-600 mb-1">이번 달 공급액</p>
                  <p className="text-2xl font-bold text-gray-900">₩8,750,000</p>
                </div>
              </div>

              <div className="bg-white rounded-xl shadow-sm overflow-hidden">
                {tabs.map((tab) => (
                  <button
                    key={tab.id}
                    onClick={() => setActiveTab(tab.id)}
                    className={`w-full px-6 py-4 flex items-center space-x-3 transition-colors cursor-pointer ${
                      activeTab === tab.id
                        ? 'bg-blue-50 text-blue-600 border-r-4 border-blue-600'
                        : 'text-gray-700 hover:bg-gray-50'
                    }`}
                  >
                    <i className={`${tab.icon} text-xl`}></i>
                    <span className="font-medium">{tab.label}</span>
                  </button>
                ))}
              </div>
            </div>

            <div className="lg:col-span-3">
              {activeTab === 'dashboard' && (
                <div className="space-y-6">
                  <div className="grid grid-cols-1 md:grid-cols-4 gap-6">
                    <div className="bg-white rounded-xl shadow-sm p-6">
                      <div className="w-12 h-12 bg-blue-100 rounded-lg flex items-center justify-center mb-4">
                        <i className="ri-box-line text-2xl text-blue-600"></i>
                      </div>
                      <p className="text-sm text-gray-600 mb-1">공급 상품</p>
                      <p className="text-3xl font-bold text-gray-900">156</p>
                    </div>
                    <div className="bg-white rounded-xl shadow-sm p-6">
                      <div className="w-12 h-12 bg-green-100 rounded-lg flex items-center justify-center mb-4">
                        <i className="ri-store-line text-2xl text-green-600"></i>
                      </div>
                      <p className="text-sm text-gray-600 mb-1">거래 가맹점</p>
                      <p className="text-3xl font-bold text-gray-900">45</p>
                    </div>
                    <div className="bg-white rounded-xl shadow-sm p-6">
                      <div className="w-12 h-12 bg-amber-100 rounded-lg flex items-center justify-center mb-4">
                        <i className="ri-file-list-line text-2xl text-amber-600"></i>
                      </div>
                      <p className="text-sm text-gray-600 mb-1">이번 달 주문</p>
                      <p className="text-3xl font-bold text-gray-900">1,234</p>
                    </div>
                    <div className="bg-white rounded-xl shadow-sm p-6">
                      <div className="w-12 h-12 bg-purple-100 rounded-lg flex items-center justify-center mb-4">
                        <i className="ri-money-dollar-circle-line text-2xl text-purple-600"></i>
                      </div>
                      <p className="text-sm text-gray-600 mb-1">이번 달 정산</p>
                      <p className="text-2xl font-bold text-gray-900">₩8.75M</p>
                    </div>
                  </div>

                  <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                    <div className="bg-white rounded-xl shadow-sm p-6">
                      <h3 className="text-lg font-bold text-gray-900 mb-4">인기 공급 상품</h3>
                      <div className="space-y-3">
                        {products.map((product) => (
                          <div key={product.id} className="flex items-center justify-between pb-3 border-b border-gray-100 last:border-0">
                            <div>
                              <p className="font-medium text-gray-900">{product.name}</p>
                              <p className="text-xs text-gray-600">{product.merchants}개 가맹점</p>
                            </div>
                            <p className="text-sm font-semibold text-gray-900">재고 {product.stock}</p>
                          </div>
                        ))}
                      </div>
                    </div>

                    <div className="bg-white rounded-xl shadow-sm p-6">
                      <h3 className="text-lg font-bold text-gray-900 mb-4">월별 공급 추이</h3>
                      <div className="space-y-3">
                        {[
                          { month: '1월', amount: 8750000, percent: 85 },
                          { month: '12월', amount: 10200000, percent: 100 },
                          { month: '11월', amount: 7800000, percent: 76 }
                        ].map((item) => (
                          <div key={item.month}>
                            <div className="flex items-center justify-between mb-1">
                              <span className="text-sm text-gray-600">{item.month}</span>
                              <span className="text-sm font-semibold text-gray-900">₩{(item.amount / 1000000).toFixed(2)}M</span>
                            </div>
                            <div className="w-full bg-gray-200 rounded-full h-2">
                              <div className="bg-blue-600 h-2 rounded-full" style={{ width: `${item.percent}%` }}></div>
                            </div>
                          </div>
                        ))}
                      </div>
                    </div>
                  </div>

                  <div className="bg-white rounded-xl shadow-sm p-6">
                    <h3 className="text-xl font-bold text-gray-900 mb-6">최근 주문 현황</h3>
                    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
                      <div className="border border-gray-200 rounded-lg p-4">
                        <p className="text-sm text-gray-600 mb-1">주문 접수</p>
                        <p className="text-2xl font-bold text-gray-900">45</p>
                      </div>
                      <div className="border border-amber-200 rounded-lg p-4 bg-amber-50">
                        <p className="text-sm text-gray-600 mb-1">출고 준비</p>
                        <p className="text-2xl font-bold text-amber-600">28</p>
                      </div>
                      <div className="border border-blue-200 rounded-lg p-4 bg-blue-50">
                        <p className="text-sm text-gray-600 mb-1">배송 중</p>
                        <p className="text-2xl font-bold text-blue-600">67</p>
                      </div>
                      <div className="border border-green-200 rounded-lg p-4 bg-green-50">
                        <p className="text-sm text-gray-600 mb-1">배송 완료</p>
                        <p className="text-2xl font-bold text-green-600">189</p>
                      </div>
                    </div>
                  </div>
                </div>
              )}

              {activeTab === 'products' && (
                <div className="bg-white rounded-xl shadow-sm p-6">
                  <div className="flex items-center justify-between mb-6">
                    <h3 className="text-xl font-bold text-gray-900">상품 공급 관리</h3>
                    <button className="px-4 py-2 bg-blue-600 text-white text-sm font-semibold rounded-lg hover:bg-blue-700 transition-colors whitespace-nowrap cursor-pointer">
                      <i className="ri-add-line mr-2"></i>
                      상품 등록
                    </button>
                  </div>
                  <div className="overflow-x-auto">
                    <table className="w-full">
                      <thead>
                        <tr className="border-b border-gray-200">
                          <th className="text-left py-3 px-4 text-sm font-semibold text-gray-700">상품명</th>
                          <th className="text-left py-3 px-4 text-sm font-semibold text-gray-700">카테고리</th>
                          <th className="text-left py-3 px-4 text-sm font-semibold text-gray-700">공급가</th>
                          <th className="text-left py-3 px-4 text-sm font-semibold text-gray-700">재고</th>
                          <th className="text-left py-3 px-4 text-sm font-semibold text-gray-700">거래처</th>
                          <th className="text-left py-3 px-4 text-sm font-semibold text-gray-700">관리</th>
                        </tr>
                      </thead>
                      <tbody>
                        {products.map((product) => (
                          <tr key={product.id} className="border-b border-gray-100 hover:bg-gray-50">
                            <td className="py-4 px-4 text-sm font-medium text-gray-900">{product.name}</td>
                            <td className="py-4 px-4 text-sm text-gray-900">{product.category}</td>
                            <td className="py-4 px-4 text-sm text-gray-900">₩{product.price.toLocaleString()}</td>
                            <td className="py-4 px-4 text-sm text-gray-900">{product.stock}</td>
                            <td className="py-4 px-4 text-sm text-gray-900">{product.merchants}개</td>
                            <td className="py-4 px-4">
                              <button className="text-blue-600 hover:text-blue-700 mr-3 cursor-pointer">
                                <i className="ri-edit-line text-lg"></i>
                              </button>
                              <button className="text-red-600 hover:text-red-700 cursor-pointer">
                                <i className="ri-delete-bin-line text-lg"></i>
                              </button>
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                </div>
              )}

              {activeTab === 'orders' && (
                <div className="bg-white rounded-xl shadow-sm p-6">
                  <h3 className="text-xl font-bold text-gray-900 mb-6">주문 관리</h3>
                  <div className="space-y-4">
                    {[
                      { id: 1, merchant: '믿음서점', product: '성경 가죽 커버', quantity: 50, amount: 2250000, status: '출고완료', date: '2025-01-15' },
                      { id: 2, merchant: '은혜문구', product: '묵상 노트', quantity: 100, amount: 1800000, status: '출고준비', date: '2025-01-14' },
                      { id: 3, merchant: '찬양뮤직', product: '찬양 악보집', quantity: 30, amount: 840000, status: '주문확인', date: '2025-01-14' }
                    ].map((order) => (
                      <div key={order.id} className="border border-gray-200 rounded-lg p-4 hover:shadow-md transition-all">
                        <div className="flex items-center justify-between mb-3">
                          <div>
                            <p className="font-semibold text-gray-900">주문번호: #{order.id.toString().padStart(6, '0')}</p>
                            <p className="text-sm text-gray-600">{order.date}</p>
                          </div>
                          <span className={`px-3 py-1 rounded-full text-xs font-semibold ${
                            order.status === '출고완료' ? 'bg-green-100 text-green-700' :
                            order.status === '출고준비' ? 'bg-amber-100 text-amber-700' :
                            'bg-gray-100 text-gray-700'
                          }`}>
                            {order.status}
                          </span>
                        </div>
                        <div className="grid grid-cols-3 gap-4 mb-3">
                          <div>
                            <p className="text-sm text-gray-600">가맹점</p>
                            <p className="font-medium text-gray-900">{order.merchant}</p>
                          </div>
                          <div>
                            <p className="text-sm text-gray-600">상품</p>
                            <p className="font-medium text-gray-900">{order.product}</p>
                          </div>
                          <div>
                            <p className="text-sm text-gray-600">수량</p>
                            <p className="font-medium text-gray-900">{order.quantity}개</p>
                          </div>
                        </div>
                        <div className="flex items-center justify-between pt-3 border-t border-gray-100">
                          <div>
                            <p className="text-sm text-gray-600">공급 금액</p>
                            <p className="font-bold text-gray-900">₩{order.amount.toLocaleString()}</p>
                          </div>
                          <button className="px-4 py-2 bg-blue-600 text-white text-sm font-semibold rounded-lg hover:bg-blue-700 transition-colors whitespace-nowrap cursor-pointer">
                            처리하기
                          </button>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              )}

              {activeTab === 'inventory' && (
                <div className="bg-white rounded-xl shadow-sm p-6">
                  <h3 className="text-xl font-bold text-gray-900 mb-6">재고 관리</h3>
                  <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-6">
                    <div className="border border-gray-200 rounded-lg p-4">
                      <p className="text-sm text-gray-600 mb-1">총 재고</p>
                      <p className="text-3xl font-bold text-gray-900">2,000</p>
                    </div>
                    <div className="border border-red-200 rounded-lg p-4 bg-red-50">
                      <p className="text-sm text-gray-600 mb-1">부족 재고</p>
                      <p className="text-3xl font-bold text-red-600">12</p>
                    </div>
                  </div>
                  <div className="space-y-4">
                    {products.map((product) => (
                      <div key={product.id} className="flex items-center justify-between p-4 border border-gray-200 rounded-lg">
                        <div className="flex-1">
                          <p className="font-semibold text-gray-900">{product.name}</p>
                          <p className="text-sm text-gray-600">{product.category}</p>
                        </div>
                        <div className="text-right">
                          <p className={`text-2xl font-bold ${product.stock < 300 ? 'text-red-600' : 'text-gray-900'}`}>
                            {product.stock}
                          </p>
                          <p className="text-sm text-gray-600">재고</p>
                        </div>
                        <button className="ml-4 px-4 py-2 bg-blue-600 text-white text-sm font-semibold rounded-lg hover:bg-blue-700 transition-colors whitespace-nowrap cursor-pointer">
                          입고
                        </button>
                      </div>
                    ))}
                  </div>
                </div>
              )}

              {activeTab === 'settlement' && (
                <div className="space-y-6">
                  <div className="bg-gradient-to-br from-blue-600 to-blue-700 rounded-xl shadow-lg p-8 text-white">
                    <p className="text-lg mb-2">총 정산액</p>
                    <p className="text-5xl font-bold mb-6">₩105,000,000</p>
                    <div className="grid grid-cols-3 gap-4">
                      <div className="bg-white/20 rounded-lg p-4">
                        <p className="text-sm text-blue-100 mb-1">이번 달</p>
                        <p className="text-2xl font-bold">₩8.75M</p>
                      </div>
                      <div className="bg-white/20 rounded-lg p-4">
                        <p className="text-sm text-blue-100 mb-1">지난 달</p>
                        <p className="text-2xl font-bold">₩10.2M</p>
                      </div>
                      <div className="bg-white/20 rounded-lg p-4">
                        <p className="text-sm text-blue-100 mb-1">평균</p>
                        <p className="text-2xl font-bold">₩8.75M</p>
                      </div>
                    </div>
                  </div>

                  <div className="bg-white rounded-xl shadow-sm p-6">
                    <h3 className="text-xl font-bold text-gray-900 mb-6">월별 정산 내역</h3>
                    <div className="space-y-4">
                      {[
                        { month: '2025년 1월', amount: 8750000, status: '정산완료' },
                        { month: '2024년 12월', amount: 10200000, status: '정산완료' },
                        { month: '2024년 11월', amount: 7800000, status: '정산완료' },
                        { month: '2024년 10월', amount: 8900000, status: '정산완료' }
                      ].map((item, index) => (
                        <div key={index} className="flex items-center justify-between pb-4 border-b border-gray-100 last:border-0">
                          <div>
                            <p className="font-medium text-gray-900">{item.month}</p>
                            <span className="text-xs px-2 py-1 bg-green-100 text-green-700 rounded-full">
                              {item.status}
                            </span>
                          </div>
                          <p className="text-xl font-bold text-gray-900">₩{item.amount.toLocaleString()}</p>
                        </div>
                      ))}
                    </div>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>

      <Footer />
    </div>
  );
}
